module.exports = __webpack_public_path__ + "img/dinners-club.e4f4078.svg";